import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "yxsj",
  "use": "yxsj-usage",
  "viewBox": "0 0 44 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 44 32\" id=\"yxsj\"><path fill-rule=\"evenodd\" d=\"M20.999,31.999 L20.999,27.999 L43.999,27.999 L43.999,31.999 L20.999,31.999 ZM20.999,21.0 L43.999,21.0 L43.999,25.0 L20.999,25.0 L20.999,21.0 ZM25.999,12.999 L43.999,12.999 L43.999,17.0 L25.999,17.0 L25.999,12.999 ZM0.0,0.0 L43.999,0.0 L43.999,6.999 L0.0,6.999 L0.0,0.0 ZM17.0,31.999 L0.0,31.999 L0.0,12.999 L17.0,12.999 L17.0,31.999 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol